import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2MutationResult,
  IIndirectTaxFilingV2TriggerBreakdownParams,
  IIndirectTaxFilingV2TriggerBreakdownResponse,
} from './types';

/**
 * POST /api/v1/new-sales-tax/corporations/:corporationId/tax-breakdowns/generate
 *
 * Re-runs tax-breakdown generation for a list of filings (max 100). Logical
 * backend forwards the `filing_ids[]` JSON body to sales-tax-api-2's
 * `/tax-breakdowns/trigger` endpoint. Returns the same envelope as the
 * existing legacy wrapper, but lifts the singular-filing-id constraint.
 */
export async function triggerIndirectTaxFilingsV2BreakdownGeneration({
  params,
  token,
}: {
  params: IIndirectTaxFilingV2TriggerBreakdownParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2TriggerBreakdownResponse>
> {
  try {
    if (!params.filingIds || params.filingIds.length === 0) {
      return { success: false, error: 'filingIds must be a non-empty array' };
    }

    const url = `new-sales-tax/corporations/${params.corporationId}/tax-breakdowns/generate`;
    const response = await fetcher(
      url,
      { method: 'POST', body: { filing_ids: params.filingIds } },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to trigger tax-breakdown generation',
      };
    }
    return {
      success: true,
      data: {
        jobId: json?.data?.job_id,
        message: json?.message ?? '',
      },
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to trigger tax-breakdown generation',
    };
  }
}
